import React from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router-dom";
import { setSportType } from "../../shared/store/actions/advisor";
import { getSportTypes } from "../../shared/store/selectors/advisor";
import SportTypesWebUI from "../../components/Advisor/SportTypes";

class SportTypes extends React.Component {
  selectSportType = sportType => {
    this.props.setSportType(sportType.id).then(props => {
      if (sportType.has_variant) {
        this.props.history.push("/sport-variants");
      } else {
        this.props.history.push("/parameters");
      }
    });
  };

  render() {
    return (
      <SportTypesWebUI
        advisor={this.props.advisor}
        items={this.props.sportTypes}
        onSelect={this.selectSportType}
      />
    );
  }
}

const mapStateToProps = state => ({
  sportTypes: getSportTypes(state).filter(sportType => sportType.active),
  advisor: state.advisor
});

export default connect(
  mapStateToProps,
  { setSportType }
)(
  withNamespaces(["sportTypes", "common"], { wait: true })(
    withRouter(SportTypes)
  )
);
